import { render } from "../templates/conference-modal.html?vue&type=template&id=228d5b46"
import script from "./ConferenceModal.vue?vue&type=script&lang=js"
export * from "./ConferenceModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__